<template>
  <div class="px-3">
    <div class="question-group" ref="mainContainer">
      <div class="py-5">
        <template v-if="showPreview">
          <div v-for="question in pageList" :key="question.q_id" class="relative mb-4 pb-4 last:mb-0">
            <preview-question :question="question" />
            <div class="absolute inset-0"></div>
          </div>
        </template>
        <template v-else>
          <template v-if="enabledVoteViewSurvey">
            <div>
              <vote-answer-question
                  v-for="question in pageList"
                  :key="question.q_id"
                  :data-id="question.q_id"
                  :question="question"
                  class="py-2.5 mb-4 last:mb-0"
              />
            </div>
          </template>
          <template v-else>
            <question
                v-for="question in pageList"
                :key="question.q_id"
                :data-id="question.q_id"
                :question="question"
                class="py-2.5 mb-4 last:mb-0"
            />
          </template>
        </template>
      </div>
      <div class="px-5">
        <div class="flex van-button--auto">
          <van-button
              v-if="showPreBtn"
              size="large"
              type="primary"
              :loading="loading"
              :disabled="loading"
              class="mr-2 flex-1"
              @click="$bus.showPrevPage"
          >
            <span> {{ buttonOption.prevText }}</span>
          </van-button>
          <van-button
              :block="!showPreBtn"
              size="large"
              :loading="loading"
              :disabled="loading || nextPageBtnDisabled || submitBtnDisabled"
              :class="{ 'ml-2 flex-1': showPreBtn }"
              type="primary"
              @click="$bus.submitOrNextPage"
          >
            <template v-if="minSubmitAnswerTimer > 0 && (!isSofgPageStart || isLastPage)">
              <span>{{ minSubmitAnswerTimer }}秒后继续</span></template
            >
            <span v-else>{{ (isLastPage&&!isSoftPage) ? buttonOption.submitText : buttonOption.nextText }}</span>
          </van-button>
        </div>
      </div>
    </div>
    <div class="relative pt-3" ref="footerContainer">
      <div class="px-5">
        <!-- <div class="copyright" v-if="showCopyright">
          <span class="text-medium">调研工厂 提供技术支持</span> |
          <a target="_blank" class="text-medium text-theme-text-gray" href="https://survey.work/s/mZZZZfiJ">举报</a>
        </div> -->
        <div ref="banner">
          <div id="contentBannerAd"></div>
        </div>
      </div>
      <!-- 网站协议文案提示 -->
      <DygcFooter class="copyright" isReport v-if="footerStatus" />
    </div>
  </div>
</template>

<script>
import { busGetters } from 'dygc'
import Question from '@/components/Question'
import PreviewQuestion from '@/components/PreviewQuestion'
import DygcFooter from 'components/dygc-footer-bottom/mobile'
import { initBannerAdsense } from '../../plugins/adsense'
import { getPageScrollEl } from '../assets/js/scroll'
import VoteAnswerQuestion from './VoteAnswerQuestion.vue'

export default {
  name: 'AnswerContent',
  components: { VoteAnswerQuestion, PreviewQuestion, Question, DygcFooter },
  props: {
    footerStatus: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    enabledVoteViewSurvey(){
      return this.$bus.survey.otherSetting.enabledVoteViewSurvey
    },
    showPreBtn() {
      return this.enablePrePage && this.currentPageNum
    },
    minSubmitAnswerTimer() {
      if (this.isLastPage) {
        const minAnswerTime = this.minAnswerTime
        const minPageAnswerTime = this.minPageAnswerTime
        if (minAnswerTime && minPageAnswerTime) {
          return Math.max(minPageAnswerTime, minAnswerTime)
        } else if (minAnswerTime) {
          return minAnswerTime
        } else {
          return minPageAnswerTime
        }
      } else {
        return this.minPageAnswerTime
      }
    },
    submitBtnDisabled() {
      if (this.isLastPage) {
        return this.minAnswerTime > 0
      } else {
        return false
      }
    },
    ...busGetters([
      'loading',
      'isLastPage',
      'isSoftPage',
      'pageList',
      'minAnswerTime',
      'nextPageBtnDisabled',
      'minPageAnswerTime',
      'enablePrePage',
      'currentPageNum',
      'buttonOption',
      'showCopyright',
      'showPreview',
      'isSofgPageStart'
    ])
  },
  mounted() {
    this.initHeight()
    this.initBannerAdsense()
  },
  methods: {
    initBannerAdsense() {
      if (this.$bus.survey.otherSetting.enableAdsense) {
        initBannerAdsense('contentBannerAd', {
          success: () => {
            this.$nextTick(() => {
              this.$refs.banner.style.marginTop = '10px'
              this.initHeight()
            })
          }
        })
      }
    },
    initHeight() {
      let copyrightEl = this.$refs.footerContainer.getElementsByClassName('copyright')[0]
      // const bannerHeight = this.$refs.banner.clientHeight
      // this.$refs.footerContainer.style.paddingBottom = copyrightEl?.clientHeight + 30 + 'px'
      const innerHeight = getPageScrollEl()?.clientHeight
      const mainOffsetTop = this.$refs.mainContainer.offsetTop
      const mainMinHeight = innerHeight - mainOffsetTop - this.$refs.footerContainer?.clientHeight
      console.log(innerHeight , mainOffsetTop , this.$refs.footerContainer?.clientHeight)
      this.$refs.mainContainer.style.minHeight = mainMinHeight + 'px'
    }
  },
  watch: {
    pageList: {
      handler() {
        this.initHeight()
        // this.initBannerAdsense()
      }
    }
  }
}
</script>
